import React from "react";
import { RouteComponentProps } from "@reach/router";
import { Typography } from "@material-ui/core";
import { ContainerCardLayout } from "components/haven-design";
import ClientInterestRows from "./client-interests";

const ClientApplicationContainer: React.FC<RouteComponentProps> = () => (
  <ContainerCardLayout title="My Applications">
    <ClientInterestRows />
    <div style={{ marginTop: 36, textAlign: "center" }}>
      <Typography variant="h6">
        Contact
      </Typography>
      <p>
            If you have any questions, you can always contact us.<br/>
        <a href="mailto:support@havenconnect.com">support@havenconnect.com</a>
      </p>
    </div>
  </ContainerCardLayout>
);
export default ClientApplicationContainer;

